import {useSelector} from "react-redux";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {fetchDistrictsMonthlyStatsApi} from "../api/fetch_districts_monthly_stats";
import {getDistrictRegionsByParentApi} from "../api/get_district_regions_by_parent_api";
import {PricesViewType} from "../helpers/prices_view_type";
import {getPricesAvailableDate} from "./get_prices_available_date";

// Months-earlier offset getDistrictsMonthlyStats was already called with for "current" data (see getPricesAvailableDate).
export const CURRENT_MONTHS_EARLIER = 1;

// How far back getDistrictsMonthlyStats is asked to fetch - exactly 12 months before the "current" row
// (CURRENT_MONTHS_EARLIER), so the same fetch also covers the year-ago comparison month, no second request needed.
export const MAX_BIGDATA_MONTHS_EARLIER = 13;

// Shared by the route prefetch and the hooks - the server and the browser have to build the same cache key,
// otherwise the hydrated page would refetch the districts instead of reading them from the store.
export const getDistrictsMonthlyStatsQuery = (regionSlug: string, type: PricesViewType, date?: string) => ({
    regionSlug,
    type,
    date,
    monthsEarlierRange: {from: MAX_BIGDATA_MONTHS_EARLIER, to: CURRENT_MONTHS_EARLIER}
});

export const useDistrictsPriceData = (region: IRegionReportPrice, type: PricesViewType) => {
    const pricesAvailableDate = useSelector((store: IRPStore) => store.report.price.pricesAvailableDate);

    const districtRegionsQuery = getDistrictRegionsByParentApi.endpoints.getDistrictRegionsByParent.useQuery(region.id);
    const districtDataQuery = fetchDistrictsMonthlyStatsApi.endpoints.getDistrictsMonthlyStats.useQuery(
        getDistrictsMonthlyStatsQuery(region.slug, type, pricesAvailableDate?.date)
    );

    return {
        districtRegions: districtRegionsQuery.currentData,
        districtData: districtDataQuery.currentData,
        referenceDate: getPricesAvailableDate(pricesAvailableDate?.date),
        isLoading: districtRegionsQuery.isFetching || districtDataQuery.isFetching
    };
};
import {useSelector} from "react-redux";

import type {IRPStore} from "../../../app/rp_reducer";
import type {IRegionReportPrice} from "../../../region/types/IRegionReportPrice";
import {fetchDistrictsMonthlyStatsApi} from "../api/fetch_districts_monthly_stats";
import {getDistrictRegionsByParentApi} from "../api/get_district_regions_by_parent_api";
import {PricesViewType} from "../helpers/prices_view_type";
import {getPricesAvailableDate} from "./get_prices_available_date";

// Months-earlier offset getDistrictsMonthlyStats was already called with for "current" data (see getPricesAvailableDate).
export const CURRENT_MONTHS_EARLIER = 1;

// How far back getDistrictsMonthlyStats is asked to fetch - exactly 12 months before the "current" row
// (CURRENT_MONTHS_EARLIER), so the same fetch also covers the year-ago comparison month, no second request needed.
export const MAX_BIGDATA_MONTHS_EARLIER = 13;

// Shared by the route prefetch and the hooks - the server and the browser have to build the same cache key,
// otherwise the hydrated page would refetch the districts instead of reading them from the store.
export const getDistrictsMonthlyStatsQuery = (regionSlug: string, type: PricesViewType, date?: string) => ({
    regionSlug,
    type,
    date,
    monthsEarlierRange: {from: MAX_BIGDATA_MONTHS_EARLIER, to: CURRENT_MONTHS_EARLIER}
});

export const useDistrictsPriceData = (region: IRegionReportPrice, type: PricesViewType) => {
    const pricesAvailableDate = useSelector((store: IRPStore) => store.report.price.pricesAvailableDate);

    const districtRegionsQuery = getDistrictRegionsByParentApi.endpoints.getDistrictRegionsByParent.useQuery(region.id);
    const districtDataQuery = fetchDistrictsMonthlyStatsApi.endpoints.getDistrictsMonthlyStats.useQuery(
        getDistrictsMonthlyStatsQuery(region.slug, type, pricesAvailableDate?.date)
    );

    return {
        districtRegions: districtRegionsQuery.currentData,
        districtData: districtDataQuery.currentData,
        referenceDate: getPricesAvailableDate(pricesAvailableDate?.date),
        isLoading: districtRegionsQuery.isFetching || districtDataQuery.isFetching
    };
};
